import React from 'react'
import {Image} from 'semantic-ui-react'
import Logo from '../images/logo.png';
import Album from "../images/album.png";
import Bg from '../images/bg2.jpg'
import Bg1 from '../images/bg3.jpg'
import Bg2 from '../images/bg4.jpg'



const Hero = () => {
    return (
        <div className='hero'>
            
            <div className="text">
                <h1>Taste Of Love</h1>
                <p> Taste of Love is the tenth extended play by South Korean girl group
            Twice. It was released on June 11, 2021, through JYP Entertainment
            and Republic Records</p>
             <a href="https://www.twiceshop.com/products/taste-of-love-digital-album" target='_blank' >Preorder Now</a>  
            </div>
            <div className="image">
                <Image.Group size='small'>
                <Image src={Bg} />
                <Image src={Bg1} />
                <Image src={Bg2} />
                    
              
                </Image.Group>
            </div>
          
        </div>
    )
}

export default Hero
